export default __webpack_public_path__ + "static/media/not_saved.2b185545.svg";